import React from "react";
import { useTranslate } from "@/hooks/use-translate/useTranslate";

interface FormattedTranslationProps {
  label: string;
  dataToInsert?: string[];
}

const FormattedTranslation = ({
  label,
  dataToInsert = [""],
}: FormattedTranslationProps) => {
  const translate = useTranslate();
  const regex = /(<strong>.*?<\/strong>|<em>.*?<\/em>)/g;

  const parts = translate(label, dataToInsert).split(regex);

  return (
    <span>
      {parts.map((part, index) => {
        if (part.startsWith("<strong>") && part.endsWith("</strong>")) {
          return (
            <strong className="font-ib-bold" key={index}>
              {part.slice(8, -9)}
            </strong>
          );
        }
        if (part.startsWith("<em>") && part.endsWith("</em>")) {
          return <em key={index}>{part.slice(4, -5)}</em>;
        }
        return <React.Fragment key={index}>{part}</React.Fragment>;
      })}
    </span>
  );
};

export default FormattedTranslation;
